module.exports = __webpack_public_path__ + "img/logoLeCleire.ba3dce27.png";